
import { defineComponent } from 'vue';
import TheCharacter from '@/components/TheCharacter.vue';

export default defineComponent({
  components: { TheCharacter },
  data() {
    return {
      downloadText: 'Download Image'
    };
  },
  methods: {
    downloadSVGAsPNG() {
      window.scrollTo({
        top: 0
      });
      this.downloadText = 'Loading...';
      const svg = document.getElementsByClassName(
        'viewer__avatar'
      )[0] as HTMLElement;
      if (svg == null) return;
      import('html2canvas').then(module => {
        const html2canvas = module.default;
        html2canvas(svg, {
          foreignObjectRendering: false,
          allowTaint: true,
          useCORS: true,
          scale: svg.clientWidth < 300 ? 3 : 1
        }).then(canvas => {
          this.downloadCanvas(canvas);
          this.downloadText = 'Download Image';
        });
      });
    },
    downloadCanvas(canvas: HTMLCanvasElement) {
      document.body.appendChild(canvas);
      const dataURL = canvas.toDataURL('image/png');
      const a = document.createElement('a');
      const myEvt = new MouseEvent('click');
      a.download = 'ac-avatar.png';
      a.href = dataURL;
      a.dispatchEvent(myEvt);
    }
  }
});
